import React, { useEffect } from 'react';
import { fromNow } from '../../utilities/fromNowWrapper.js';
import {
  GeckoCardTable,
  GeckoAvatar,
  GeckoToastService,
  GeckoDialogService,
  GECKO_CONSTS,
  GeckoModalService,
} from '../../ui';
import ContactModal from './components/ContactModal';
import GeckoRequest from 'services/gecko-request';
import NavBar from '../../components/NavBar.jsx';
import ContactMergeModal from 'components/ContactMergeModal';
import Loader from 'components/Loader';
import GeckoLocation from 'services/gecko-location';
import { CONSTS } from 'constants/index.js';
import { useRedux } from 'services/gecko-store/redux';
import { renderError } from 'services/gecko-error';
import './index.scss';
import { fetchContacts } from './actions';
import { handleDeleteContact } from '../conversations/utils';
const mapStateToProps = (state) => {
  return {
    fetching: state.contactsRoute.fetching,
    page: state.contactsRoute.page,
    orderBy: state.contactsRoute.orderBy,
    total: state.contactsRoute.total,
    order: state.contactsRoute.order,
    contacts: state.contactsRoute.contacts,
    locationSlug: state.location.slug,
    loggedInUser: state.appState.loggedInUser,
    search: state.location.params.search || '',
  };
};

function Contacts() {
  const {
    fetching,
    page,
    orderBy,
    total,
    order,
    contacts,
    locationSlug,
    loggedInUser,
    search,
  } = useRedux(mapStateToProps);

  const mineLink = {
    to: '/contacts/mine',
    activeClassName: 'active',
    linkText: 'My Contacts',
  };
  const allLink = {
    to: '/contacts/all',
    activeClassName: 'active',
    linkText: 'All Contacts',
  };
  // If the user isn't allowed to access all Contacts only show them the My Contacts filter
  const isRestricted =
    loggedInUser.permissions &&
    loggedInUser.permissions[CONSTS.PERMISSIONS.OWNED_CONTACTS_ONLY];

  useEffect(() => {
    if (
      locationSlug === 'all' &&
      loggedInUser.permissions &&
      loggedInUser.permissions[CONSTS.PERMISSIONS.OWNED_CONTACTS_ONLY]
    ) {
      GeckoLocation.goTo('/contacts/mine');
      return;
    }
    fetchContacts({
      page: page || 1,
      order: 'DESC',
      orderBy: 'last_message_time',
      search,
    });
  }, []);

  useEffect(() => {
    fetchContacts({ page: 1 });
  }, [locationSlug]);

  useEffect(() => {
    fetchContacts({ page: 1, search });
  }, [search]);

  const openMergeModal = (contactId) => {
    new GeckoModalService()
      .open(() => <ContactMergeModal contact_id={contactId} />)
      .then(() => fetchContacts({ page }));
  };

  const nameColumn = {
    key: 'name',
    name: 'Name',
    sortable: 'full_name',
    render: (_name, contact) => {
      return (
        <div className="avatar-col">
          <GeckoAvatar
            name={contact.full_name}
            first_name={contact.first_name}
            last_name={contact.last_name}
            color={contact.additional.avatar_colour}
          />
          <span>&nbsp;{contact.full_name}</span>
        </div>
      );
    },
    width: '33.3%',
  };

  const emailColumn = {
    key: 'email',
    name: 'Email',
    sortable: true,
    width: '33.3%',
  };

  const lastMessageColumn = {
    key: 'last_message_time',
    name: 'Last message',
    sortable: true,
    width: '33.3%',
    render: (value) => {
      return value ? fromNow(Date.parse(value)) : 'Never';
    },
  };

  const actionColumn = {
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
    items: [
      {
        name: 'Merge Contact',
        handler: (row) => openMergeModal(row.id),
      },
      {
        name: 'Delete',
        handler: (contact) => handleDeleteContact(contact.id, page),
      },
    ],
  };

  const handleRowClick = (contact) => {
    new GeckoModalService()
      .open(() => {
        return <ContactModal contact_id={contact.id} />;
      })
      .then(() => {
        fetchContacts();
      });
  };

  const pagination = {
    changeOrder: (sortKey) => {
      if (orderBy === sortKey) {
        fetchContacts({
          page,
          orderBy: sortKey,
          order: order === 'ASC' ? 'DESC' : 'ASC',
        });
      } else {
        fetchContacts({ page, orderBy: sortKey, order: 'ASC' });
      }
    },
    changePage: (page) => fetchContacts({ page }),
    current_page: page,
    order_by: orderBy,
    sort: order,
    total_items: total,
    total_pages: Math.ceil(total / 20),
  };

  return (
    <Loader isLoading={fetching} spinnerPageCenter>
      <div className={`Contacts`}>
        <NavBar navLinks={isRestricted ? [mineLink] : [allLink, mineLink]} />
        <div className="content-margin">
          <GeckoCardTable
            onSearch={(search) =>
              GeckoLocation.goTo(GeckoLocation.location.pathname, { search })
            }
            name="Contacts"
            rows={contacts}
            cols={[nameColumn, emailColumn, lastMessageColumn, actionColumn]}
            rowHandler={handleRowClick}
            pagination={pagination}
            headerProps={{ searchPlaceholder: 'Search contacts' }}
          />
        </div>
      </div>
    </Loader>
  );
}

export default Contacts;
